import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectAccountInfo = (state) => state.accountInfo || initialState

const makeSelectAccountInfo = () => createSelector(
  selectAccountInfo,
  (state) => state
)

export {
  selectAccountInfo,
  makeSelectAccountInfo
}
